$(function () {
  $('#inbox-element').on('click', function () {
    $('#inbox').toggle()
  });
});
